import Composition from 'src/lib/HOC/Composition';
import { Data } from './data';
import PushDownPanelItem from './index';

const { compositionFunction, component } = Composition(PushDownPanelItem)<typeof Data>(
  ({ fields, props, rendering }) => ({
    analytics: {
      action: fields?.['Pod Item Title']?.value || '',
      category: 'pushdown_panel',
      label: props?.title?.value,
      guid: rendering?.uid || '',
    },
    classes: rendering?.classes,
    id: rendering?.uid || '',
    image: fields?.['Pod Item Icon'],
    props,
    rendering,
    title: fields?.['Pod Item Title'],
  })
);

export default component;
export { compositionFunction };
